import { DateObject } from '../reusables/date-object';
import { Icon } from '../reusables/icon';

/**
 * Blueprint for the address object
 */
export class Bank {
  public id: number;
  public IBAN: string;
  public BIC: string;
  public bankName: string;
  public address: any | null;
  public sepaMandates: Array<SepaMandate> = [];
  public isTixxSelect: Icon | string;
  public type: string;

  public constructor(bank?: Bank) {
    this.id = bank.id;
    this.IBAN = bank.IBAN;
    this.BIC = bank.BIC;
    this.bankName = bank.bankName;
    this.address = bank.address;
    this.isTixxSelect = bank.type === 'lottery' ? new Icon('#esf-icon-clover-leaf-16', 'Tixx-Select') : '';

    for (const sepaMandate of bank.sepaMandates) {
      this.sepaMandates.push(new SepaMandate(sepaMandate));
    }
  }
}

/**
 * Blueprint for the SEPA mandates object
 */
export class SepaMandate {
  public id: number;
  public bankAccount: string;
  public referenceNumber: string;
  public type: string;
  public signatureDate: DateObject;
  public status: string;
  public lastExecutionDate: DateObject;
  public signaturePlace: string;

  public constructor(data?: any) {
    this.id = data.id;
    this.bankAccount = data.bankAccount;
    this.referenceNumber = data.referenceNumber;
    this.type = data.type;
    this.signatureDate = new DateObject(data.signatureDate, 'dd.MM.yyyy');
    this.status = data.status;
    this.lastExecutionDate = new DateObject(data.lastExecutionDate, 'dd.MM.yyyy');
    this.signaturePlace = data.signaturePlace;
  }
}
